/**
 * DataBrowserContainer
 *
 * useDataBrowser 훅의 상태를 DataBrowserScreen props로 그대로 배선.
 * 로딩/에러는 전체 폴백이 아니라 그리드 영역에서 렌더링(선택 상태는 훅이 보존).
 *
 * AdminApp에서 screen === 'data-browser' 일 때 렌더링
 */

import { useAuth } from '../hooks/useAuth';
import { useDataBrowser } from '../hooks/useDataBrowser';
import { DataBrowserScreen } from '../screens/DataBrowser/DataBrowserScreen';

const LIMIT = 50;

export function DataBrowserContainer() {
  const { token } = useAuth();
  const db = useDataBrowser(token);

  return (
    <DataBrowserScreen
      moduleOptions={db.moduleOptions}
      module={db.module}
      onChangeModule={db.setModule}
      tableOptions={db.tableOptions}
      table={db.table}
      onChangeTable={db.setTable}
      search={db.search}
      onSearchChange={db.setSearch}
      columns={db.columns}
      rows={db.rows}
      total={db.total}
      page={db.page}
      onPrev={() => db.setPage(Math.max(0, db.page - 1))}
      onNext={() => {
        if ((db.page + 1) * LIMIT < db.total) db.setPage(db.page + 1);
      }}
      loading={db.loading}
      error={db.error}
      onRetry={db.retry}
      selectedIndex={db.selectedIndex}
      onSelectRow={db.openDetail}
      detailOpen={db.detailOpen}
      onCloseDetail={db.closeDetail}
      fk={db.fk}
      related={db.related}
      relatedLoading={db.relatedLoading}
      relatedError={db.relatedError}
      onOpenFk={db.openRelated}
    />
  );
}
